import React, { useEffect, useState } from 'react';
import { displayDuration } from '../../utils/parsing';
import DashboardLoader from './DashboardLoader';

import './dashboard-refresh.css';

const REFRESH_SECONDS = 180;
const TICK_INTERVAL = 0.25;

const DashboardRefresher = ({ buildings, date }) => {
  const [counter, setCounter] = useState(0);
  const [timer, setTimer] = useState(REFRESH_SECONDS);
  const { val, unit } = displayDuration(timer.toFixed(0), 'seconds');

  useEffect(() => {
    if (timer <= 0) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setCounter((c) => c + 1);
      setTimer(REFRESH_SECONDS);
    }

    const refreshFire = setTimeout(() => setTimer((t) => t - TICK_INTERVAL), TICK_INTERVAL * 1000);
    return () => clearTimeout(refreshFire);
  }, [timer]);
  return (
    <div className="refresher">
      <DashboardLoader tick={counter} buildings={buildings} date={date} />
      <span className="refresh-text">
        Next refresh in {val} {unit}...
      </span>
    </div>
  );
};

export default DashboardRefresher;
